import { render, staticRenderFns } from "./ItsContractCustomsAffair.vue?vue&type=template&id=41c2e635&scoped=true&"
import script from "./ItsContractCustomsAffair.vue?vue&type=script&lang=js&"
export * from "./ItsContractCustomsAffair.vue?vue&type=script&lang=js&"
import style0 from "./ItsContractCustomsAffair.vue?vue&type=style&index=0&id=41c2e635&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c2e635",
  null
  
)

export default component.exports